/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { ChangeDetectorRef, Component, ElementRef, inject, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthState } from '../../../core/security/state/auth.state';
import { AppConfigState } from '../../../core/state/appConfig/app-config.state';
import { BottomSheetEnabled } from '../../../types/BottomSheetEnabled';
import { PersistUserMapConfigState, ResetUserMapConfigState } from '../state/map-config.actions';
import { MapConfigState } from '../state/map-config.state';
import { MatToolbar } from '@angular/material/toolbar';
import { LayoutDirective, LayoutAlignDirective } from '@ngbracket/ngx-layout/flex';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MapLegendContainerComponent } from './map-legend-container.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'dash-gis-map-legend',
    host: {
        class: 'dash-gis-map-legend',
    },
    templateUrl: './map-legend.component.html',
    styleUrls: ['./map-legend.component.scss'],
    imports: [
        MatToolbar,
        LayoutDirective,
        LayoutAlignDirective,
        MatIconButton,
        MatTooltip,
        MatIcon,
        MapLegendContainerComponent,
        AsyncPipe,
    ],
})
export class MapLegendComponent implements OnInit, BottomSheetEnabled {
    public siteName$: Observable<string> = inject(Store).select(AppConfigState.siteName);
    public isDefaultUser$: Observable<boolean> = inject(Store).select(AuthState.isDefaultUser);
    public userCustom$: Observable<boolean> = inject(Store).select(MapConfigState.userCustom);

    @Input() legendVisible: boolean;

    /**
     * @param elementRef {ElementRef}
     * @param cdr {ChangeDetectorRef}
     * @param store {Store}
     * @param data
     */
    constructor(
        public elementRef: ElementRef,
        private cdr: ChangeDetectorRef,
        private store: Store,
        @Inject(MAT_BOTTOM_SHEET_DATA) @Optional() private data: any
    ) {
        if (this.data && this.data.legendVisible) {
            this.legendVisible = this.data.legendVisible;
            this.cdr.markForCheck();
        }
    }

    ngOnInit() {}

    saveLayers() {
        this.store.dispatch(new PersistUserMapConfigState());
    }

    resetLayers() {
        this.store.dispatch(new ResetUserMapConfigState());
    }
}
